import React from "react";
export function LoanCaseDetails() {
  return (
    <div className="bg-white rounded-md shadow-sm border border-gray-200 p-4 mt-4">
      <h4 className="font-medium text-gray-900 mb-3">Loan Case Details:</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-800">
        <div>
          <strong>
            Listed loan amount
            </strong>{" "}
            (the total amount the borrower is requesting):
          {" "}
          $12,000
        </div>
        <div>
          <strong>
            Months since most recent inquiry
            </strong>{" "}
            (how long it has been since a lender last checked the credit report):
          {" "}
          5 months
        </div>
        <div>
          <strong>
            Credit utilization ratio</strong>{" "}
            (the percentage of total available credit that is currently being used):
          {" "}
          63.6%
        </div>
        <div>
          <strong>
            Total open to buy on revolving bankcards</strong>
            (the remaining credit available on credit cards after current balances):
          {" "}
          $3,755
        </div>
        <div>
          <strong>
            Ratio of total current balance to credit limit</strong>{" "}
            (how close all balances are to the combined credit limits):
         {" "}
          81.9%
        </div>
        <div>
          <strong>
            Number of open revolving accounts</strong>{" "}
            (how many active credit card or similar revolving credit accounts there are):
          {" "}
          15
        </div>
        <div>
          <strong>
            Number of payments on the loan</strong>{" "}
            (the length of the loan repayment term in months):
         {" "}
          36 months
        </div>
        <div>
          <strong>
            30+ days past-due incidences (past 2 years)</strong>{" "}
            (how many times a payment was at least 30 days late in the last 2 years):
          {" "}
          1
        </div>
        <div>
          <strong>
            Interest rate on the loan</strong>{" "}
            (the yearly cost of borrowing expressed as a percentage of the amount borrowed):
          {" "}
          14.33%
        </div>
        <div>
          <strong>
            Debt to income ratio</strong>{" "}
            (the share of monthly income that goes toward paying debts):
          {" "}
          24.37%
        </div>
        <div className="md:col-span-2">
          <strong>
            Loan description</strong>{" "}
            (the borrower’s own explanation of how they plan to use the loan):
          {" "}
          Pay off some bills
        </div>
      </div>
    </div>
  );
}
